import React from 'react';

// Components
import OrderingList from "./orderingList";

// Constants
import { PAGE, PAGE_NAME } from '@utils/constants';

function OrderingReserve(props) {

    const BREADCRUMB = [
        {
            path: PAGE.ORDER_TERMINATED,
            name: PAGE_NAME.ORDER_TERMINATED
        }
    ];

    const availableOrderingStatus = ['terminated'];

    return (
        <OrderingList {...props} breadcrumb={BREADCRUMB} availableOrderingStatus={availableOrderingStatus}/>
    );
}

export default OrderingReserve;
